import { Component, Input, OnInit } from '@angular/core';
import { EverythingSearchResult } from '../../model/everything-search-result';
import { SearchResultLinkDirective } from '../../search-result-link.directive';

@Component({
  selector: 'app-search-result-marketplace-entry',
  templateUrl: './search-result-marketplace-entry.component.html',
  styleUrls: [ './search-result-marketplace-entry.component.scss' ],
  imports: [ SearchResultLinkDirective ]
})
export class SearchResultMarketplaceEntryComponent implements OnInit {
  @Input() result: EverythingSearchResult;
  imageUrl: string;
  fallbackImageUrl = 'https://cdn.forgerock.com/logo/ping/Logo-PingIdentity-200x200.png';

  ngOnInit() {
    this.imageUrl = this.result.thumbnailUrl;
  }

}
